const monthFormat = (month) => {
  if (month < 10) {
    return `0${month}`;
  } else {
    return month.toString();
  }
};

export default monthFormat;
